import React, { useState, useEffect, useRef } from "react";
import { QrReader } from "react-qr-reader";
import { Select } from "antd";
import { apiCallPost } from "../fns/util";
import {
  ACTION_ITEM_FOOD,
  ACTION_ITEM_KIT,
  MEAL_TIMESTAMP,
} from "./SeminarServiceConfig";
import { Button } from "antd";

const { Option } = Select;
function SeminarService() {
  let [serviceState, setServiceState] = useState({
    delegateID: "",
    selectedAction: "",
    selectedDate: "",
    delegateData: null,
  });
  const delegateIDRef = useRef("");
  const handleActionChange = (value) => {
    setServiceState((prev) => ({
      ...prev,
      selectedAction: value,
      selectedDate: "",
    }));
  };

  const handleTimeStampChange = (value) => {
    setServiceState((prev) => ({
      ...prev,
      selectedDate: value,
    }));
  };

  const getDelegateInfo = async (delegate_id) => {
    try {
      const res = await apiCallPost(
        "jhgjh",
        "/conference2023/getDelegateById",
        {
          delegateId: delegate_id,
        }
      );
      setServiceState((prev) => ({
        ...prev,
        delegateData: {
          delegateName: res.delegate.name,
          delegateMobile: res.delegate.mobile,
          delegateKitHandover: !!res.delegate.kitHandover,
        },
      }));
    } catch (error) {
      console.log(error);
      setServiceState((prev) => ({ ...prev, delegateData: null }));
    }
  };
  useEffect(() => {
    if (serviceState.delegateID !== delegateIDRef.current) {
      console.log("API Call 1");
      delegateIDRef.current = serviceState.delegateID;
      getDelegateInfo(serviceState.delegateID);
    }
  }, [serviceState]);

  return (
    <div>
      <QrReader
        constraints={{ facingMode: "environment" }}
        onResult={(result, error) => {
          if (!!result) {
            if (result?.text !== delegateIDRef.current) {
              console.log("Hello");
              setServiceState((prev) => ({
                ...prev,
                delegateID:
                  result?.text.split("/")[result?.text.split("/").length - 1],
              }));
            }
          }

          if (!!error) {
            //console.info(error);
          }
        }}
        style={{ width: "100%" }}
      />

      <div>
        <div>
          <h2>Select Action: </h2>
          <Select
            placeholder="Select an option"
            style={{ width: 200 }}
            onChange={handleActionChange}
          >
            <Option value={ACTION_ITEM_FOOD}>{ACTION_ITEM_FOOD}</Option>
            <Option value={ACTION_ITEM_KIT}>{ACTION_ITEM_KIT}</Option>
          </Select>
        </div>
      </div>
      <div>
        <div>
          {serviceState.selectedAction === ACTION_ITEM_FOOD ? (
            <>
              <h2>Select Meal Timestamp: </h2>
              <Select
                placeholder="Select an option"
                style={{ width: 200 }}
                onChange={handleTimeStampChange}
              >
                {MEAL_TIMESTAMP.map((timestamp) => (
                  <Option value={timestamp}>{timestamp}</Option>
                ))}
              </Select>
            </>
          ) : serviceState.selectedAction === ACTION_ITEM_KIT ? (
            !serviceState.delegateData.delegateKitHandover ? (
              <Button
                type="primary"
                disabled={serviceState.delegateData.delegateKitHandover}
                style={{
                  backgroundColor: "#FE6B8B",
                  borderColor: "#FE6B8B",
                  fontSize: "20px",
                  fontWeight: "600",
                  height: "40px",
                  marginTop: "20px",
                }}
                onClick={() => {
                  console.log("API CALL");
                }}
              >
                Confirm Handover
              </Button>
            ) : (
              <h4>kit has already been handed over</h4>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
      {serviceState.delegateData !== null ? (
        <div>
          <h3>{serviceState.delegateData.delegateName}</h3>
          <h3>{serviceState.delegateData.delegateMobile}</h3>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default SeminarService;
